/**
 * Crypto compare icon
 */

import { APIs } from '@kattana-io/common';

/**
 * List of KTN tokens (lowercased)
 */
export const KTN_Tokens = ['0x491e136ff7ff03e6ab097e54734697bb5802fc1c', '0xdae6c2a48bfaa66b43815c5548b10800919c993e'];

/**
 *
 * @param symbols
 * @returns
 */
export const getCryptoComparePrices = async (symbols: any[]) => {
  const results = await Promise.all(
    symbols.map((s: any) => APIs.common.getTokensPrice(s))
  );

  let prices = {};
  results.map((r: any) => {
    prices = { ...prices, ...r.data.RAW };
    return null;
  });

  return prices;
};

export const getCDNIcon = (name: string) =>
  `https://github.com/alexandrebouttier/coinmarketcap-icons-cryptos/blob/main/icons/${name?.toLocaleLowerCase()}.png?raw=true`;
